import * as React from 'react';
import type { SVGProps } from 'react';
const FileCsv = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#prefix__a)">
      <path
        fill="#D24625"
        d="M12.544 0h1.63v2.233c2.91.016 5.82-.032 8.747.016a.952.952 0 0 1 1.058 1.058c.045 5.498 0 10.999.026 16.497-.026.563.053 1.188-.264 1.688-.4.29-.913.264-1.379.264H14.18v2.233h-1.71C8.32 23.225 4.16 22.513 0 21.767V2.238C4.18 1.49 8.363.762 12.544 0"
      />
      <path
        fill="#fff"
        d="M14.174 3.07v17.86h8.995V3.07zm4.378 3.394c.125.074.268.11.413.1a.8.8 0 0 0 .394-.084.27.27 0 0 0 .146-.225.33.33 0 0 0-.212-.286 5 5 0 0 0-.442-.148 4 4 0 0 1-.529-.19.5.5 0 0 1-.264-.458.53.53 0 0 1 .264-.471 1.21 1.21 0 0 1 1.228 0 .72.72 0 0 1 .264.547h-.357a.5.5 0 0 0-.174-.301.6.6 0 0 0-.376-.093.7.7 0 0 0-.326.06.24.24 0 0 0-.14.236.27.27 0 0 0 .159.23q.188.084.386.14.308.086.596.223a.55.55 0 0 1 .293.49.57.57 0 0 1-.238.481 1.39 1.39 0 0 1-1.323.013.78.78 0 0 1-.323-.643h.37a.53.53 0 0 0 .191.379m-2.844-.75c-.01-.295.083-.585.265-.82a1 1 0 0 1 .828-.36c.237-.008.47.066.659.21.162.14.264.335.285.548h-.362a.53.53 0 0 0-.212-.328.7.7 0 0 0-.391-.101.61.61 0 0 0-.53.243 1 1 0 0 0-.166.609c-.014.218.044.434.164.616a.74.74 0 0 0 .944.114.7.7 0 0 0 .228-.386h.362a1 1 0 0 1-.354.622.97.97 0 0 1-.63.209 1.02 1.02 0 0 1-.844-.355 1.28 1.28 0 0 1-.246-.82m5.533 1.13h-.448L20 4.58h.402l.621 1.852.622-1.852h.402z"
      />
      <path
        fill="#D24625"
        d="M15.129 8.578h7.088v2.585h-7.088zm0 3.86h7.088v2.585h-7.088zm0 3.86h7.088v2.585h-7.088z"
      />
      <path
        fill="#fff"
        d="m8.943 13.687-.077.296c-.093.47-.337.895-.696 1.212-.358.25-.789.374-1.225.354-.778 0-1.352-.235-1.709-.698s-.516-1.138-.516-2.032.177-1.548.53-2.014c.351-.465.904-.738 1.658-.738.429-.023.854.084 1.22.307.321.236.542.583.62.974l.078.293h2.117l-.071-.455a3.47 3.47 0 0 0-1.244-2.262 4.13 4.13 0 0 0-2.696-.857c-1.46 0-2.593.497-3.363 1.471-.659.836-1.013 1.942-1.013 3.28 0 1.34.328 2.456.974 3.266.762.97 1.915 1.463 3.44 1.463a4 4 0 0 0 2.555-.857 4.1 4.1 0 0 0 1.452-2.532l.09-.471z"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default FileCsv;




